import { Interaction } from 'ol/interaction';
import { ReactElement } from 'react';

const Index = ({ children }: { children: Array<ReactElement<Interaction> | null> }) => {
  return <div>{children}</div>;
};

export default Index;
